<template>
  <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" max-width="640">
    <v-btn icon @click="$emit('close')" absolute top right>
      <v-icon color="white">close</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="text-h5">Survey Results</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <div class="mb-3" v-for="(result, index) in results" :key="index">
          <h2 class="mb-2">{{ result.header }}</h2>
          <div v-if="result.type === 'textarea'">
            <p class="font-weight-bold">{{ result.answers[0] }}</p>
          </div>
          <div v-else>
            <p v-for="(choice, cIndex) in result.questions" :key="cIndex" class="my-0">
              <template v-if="findAnswer(choice.value, result.answers)">
                <v-icon small>done</v-icon>
                <span class="font-weight-bold">{{ formatAnswer(choice.value, result.answers) }}</span>
              </template>
              <template v-else>
                {{ choice.value }}
              </template>
            </p>
          </div>

          <v-divider class="mt-3" v-if="index < results.length - 1"></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SurveyResult',
  props: ['dialog', 'survey'],
  computed: {
    results() {
      return JSON.parse(this.survey);
    }
  },
  methods: {
    findAnswer(choiceValue, answers) {
      return answers.find(ans => ans === choiceValue || ans.startsWith(choiceValue));
    },
    formatAnswer(choiceValue, answers) {
      const ans = this.findAnswer(choiceValue, answers);
      return ans ? ans : choiceValue;
    }
  }
}
</script>

<style lang="scss" scoped>
.survey {
  width: 100%;
}
</style>
